// extracted by mini-css-extract-plugin
module.exports = {"container":"e_VG","icon":"e_WG"};